"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.workflowStepCallbacksPropType = exports.workflowNavigationPropType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

/* eslint-disable import/prefer-default-export */
var workflowStepCallbacksPropType = _propTypes.default.shape({
  setStepValidationResults: _propTypes.default.func,
  unsetStepValidationResults: _propTypes.default.func
});

exports.workflowStepCallbacksPropType = workflowStepCallbacksPropType;

var workflowNavigationPropType = _propTypes.default.shape({
  transitionToStep: _propTypes.default.func.isRequired
});

exports.workflowNavigationPropType = workflowNavigationPropType;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/browser/workflow/impl/workflowPropTypes.js
// module id = 4517
// module chunks = 25